import { colors, FOOTER_HEIGHT } from "shared/styles/constants";
import styled from "styled-components/macro";

export const StyledFooter = styled.div`
  border-top: 1px solid ${colors.black};

  grid-area: footer;
  width: 100vw;
  height: ${FOOTER_HEIGHT}px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;
